//import Libraries
import React, { Component } from 'react'
import { connect } from 'react-redux';

//import Components
import { Modal, Button } from 'reactstrap';

import Language from '../../language/language.json'

import * as resetActions from './actions/resetActions';

//import Style classes
import './ResetPassword.css';

class ResetPassword extends Component {
    constructor(props){
        super(props);
        this.state = {
            nestedModal : '',
            closeAll : false,

            email: '',
        }
    }

    toggleNested = () =>  {
        this.props.onResetAuth();
        this.setState(prevState => ({
            nestedModal : !prevState.nestedModal,
            closeAll : false
        }))
    }
    
    toggleAll = () =>  {
        this.setState(prevState => ({
            nestedModal : !prevState.nestedModal,
            closeAll : true
        }))
    }
    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.resetPassword) {
            if (!prevProps.resetPassword.success && this.props.resetPassword.success) {
                this.toggleNested();
            }
        }
    }

    render() {
        const {language} = this.props.universal

        return (
            <div>
                <Modal 
                    isOpen={this.props.modal} 
                    toggle={this.props.toggle}
                >
                    <div className="reset-container">
                        <div className="title">
                            {Language.resetPassword.title[language]}
                        </div>
                        <div className="content">
                            <div className="element">
                                <input
                                    type="email"
                                    placeholder={Language.resetPassword.email[language]}
                                    onChange={this.handleOnChange}
                                    value={this.state.username}
                                    name="email"
                                    required />
                            </div>
                            <div className="element">
                            {
                                this.props.resetPassword && this.props.resetPassword.message && 
                                (
                                    <div className="error">
                                        {this.props.resetPassword.message}
                                    </div>
                                )
                            }
                            </div>
                            <div className="element">
                                <Button 
                                    size="lg"
                                    color="warning"
                                    className="btn"
                                    onClick={() => {
                                        this.props.onSendPasswordResetEmail(this.state.email)
                                    }}
                                >
                                    {Language.resetPassword.confirm[language]}
                                </Button>
                            </div>
                        </div>
                        <div className="footer">
                        </div>
                    </div>
                    <Modal 
                        isOpen={this.state.nestedModal} 
                        toggle={this.toggleNested}
                        onClosed={this.state.closeAll ? this.props.toggle : undefined}
                    >
                        <div className="reset-container">
                            <div className="title">
                                {Language.resetPassword.success.title[language]}
                            </div>
                            <div className="content">
                                <div className="element">
                                    {Language.resetPassword.success.content[language]}
                                </div>
                                <div className="element">
                                    <Button 
                                        size="lg"
                                        color="success"
                                        className="btn"
                                        onClick={this.toggleAll}
                                    >
                                        {Language.resetPassword.success.confirm[language]}
                                    </Button>
                                </div>
                            </div>
                            <div className="footer">
                            </div>
                        </div>
                    </Modal>
            </Modal>
           </div>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
        universal : state.universal,
        resetPassword : state.sign.resetPassword,
    }
}

const mapDispatchToProps = (dispatch, ownProps)=>{
    return {
        onSendPasswordResetEmail : (email)=> {
            dispatch(resetActions.sendPasswordResetEmail(email))
        },
        onResetAuth : () => {
            dispatch({ type: 'RESET_AUTH' })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPassword.js